'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/daysAgo.js